// extracted by mini-css-extract-plugin
export var avatarContainer = "_86-0";
export var avatarTypingWave = "_86-i";
export var gray = "_86-f";
export var green = "_86-c";
export var icon = "_86-9";
export var image = "_86-1";
export var lg = "_86-6";
export var md = "_86-5";
export var presenceDot = "_86-b";
export var red = "_86-d";
export var sm = "_86-4";
export var status = "_86-a";
export var typingDot = "_86-h";
export var typingPill = "_86-g";
export var xl = "_86-7";
export var xs = "_86-3";
export var xxl = "_86-8";
export var xxs = "_86-2";
export var yellow = "_86-e";